export default __webpack_public_path__ + "static/V-ISO-YLI_Korkea_ISO_ylivalotettu-e6d2f0c7eed28906d0c354bf62a0b999.jpg";